import React from 'react';
import heroImage from '../../../../../images/verizon/openbank/hero-top.webp';
import heroImageMobile from '../../../../../images/verizon/openbank/hero-top-m.webp';

const Hero = () => {
  return (
    <div className="section hero">
      <div className="container">

        <div className="hero_grid">
          <div className="hero_grid-item -text">
            <h3 className="hero_subtitle color-red">
              Introducing Verizon + Openbank Savings<sup>1</sup>
            </h3>
            <h1 className="section_title hero_title color-red">
              Get <span className="little-bigger">4.30%</span> APY<sup>2</sup> on
              <br />{' '}
              your savings account
              <br />{' '}
              and up to <span className="little-bigger">$180</span> off<sup>3</sup>
              <br />{' '}
              your wireless bill<sup>4</sup>
            </h1>
            <div className="hero_text">
              Open a high yield savings account with Openbank
              {' '}<br className="show-tablet" />
              and get credit towards your wireless bill for up to
              {' '}<br className="show-tablet" />
              12 months. Only for Verizon customers.
            </div>
            <div className="hero_button">
              <button className="button -red">Get started</button>
            </div>
          </div>
          <div className="hero_grid-item -image">
            <div className="hero_image">
              <picture>
                <source srcSet={ heroImageMobile } media="(max-width: 768px)" />
                <img src={ heroImage } alt="OpenBank" />
              </picture>
            </div>
          </div>
        </div>
        <div className="hero_decor">
          <div className="decor-squares -center -red" />
        </div>
      </div>
    </div>
  );
};

export default Hero;
